export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_40.a858dfea.jpg";